import { useState, useContext, useEffect } from 'react'
import { ClientContext } from '../../../contexts/clientProvider'
import BaseInput from '../../General/FormsComp/Input/BaseInput'
import BaseSelect from '../../General/FormsComp/Select/BaseSelect'

const GeralCadastro = ({ newClient, handleInputChange }) => {
    const { estados } = useContext(ClientContext);
    const [municipios, setMunicipios] = useState([]);

    useEffect(() => {
        fetchData();
    }, [newClient.estado]);

    const fetchData = async () => {
        try {
            const response = await fetch(
                `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${newClient.estado}/municipios`
            );
            const data = await response.json();
            if (Array.isArray(data)) {
                setMunicipios(data.map(municipio => municipio));
            } else {
                console.error('Resposta inesperada da API:', data);
            }

        } catch (error) {
            console.error('Erro ao recuperar dados:', error);
        }
    };
    return (
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <BaseInput
                label="Nome"
                name="nome"
                value={newClient.nome}
                onChange={handleInputChange}
                type="text"
                required
            />
            
            <BaseInput
                label="CPF/CNPJ"
                name="cpf_cnpj"
                value={newClient.cpf_cnpj}
                onChange={handleInputChange}
                type="text"
                required
            />
            
            <BaseInput
                label="Telefone"
                name="telefone"
                value={newClient.telefone}
                onChange={handleInputChange}
                type="tel"
            />
            
            <BaseInput
                label="Email"
                name="email"
                value={newClient.email}
                onChange={handleInputChange}
                type="email"
            />
            
            <div className="md:col-span-2">
                <BaseInput
                    label="Endereço"
                    name="endereco"
                    value={newClient.endereco}
                    onChange={handleInputChange}
                    type="text"
                />
            </div>

            <BaseSelect
                label="Estado"
                name="estado"
                value={newClient.estado}
                onChange={handleInputChange}
                options={Object.values(estados)}
                placeholder="Selecione um estado"
                valueKey="id"
                labelKey="nome"
                required
            />
            
            <BaseSelect
                label="Cidade"
                name="cidade"
                value={newClient.cidade}
                onChange={handleInputChange}
                options={municipios || []}
                placeholder="Selecione uma cidade"
                valueKey="id"
                labelKey="nome"
                required
            />
        </div>
    )
}

export default GeralCadastro
